import moment from 'moment';

export default class VistaDate {

    constructor(data) {

        if(!moment.isMoment(data)) {

            if (typeof data === 'object' || typeof data === 'array') {
                this.timestamp = parseInt(data.timestamp);
                this.date = moment.unix(parseInt(data.timestamp));
            } else {
                this.timestamp = data;
                this.date = moment.unix(parseInt(data));

            }
        }else{
            this.date = data;
        }
        this.additional = {
            is_passed:this.date.isBefore(moment()),
            is_future:this.date.isAfter(moment()),
            no_zero_hour_long:this.date.format('H'),
            no_zero_hour_24:this.date.format('H'),
            minute:this.date.format('mm'),
            am_pm:this.date.format('a'),
            string_short_day_of_week:this.date.format('ddd'),
            string_long_day_of_week:(()=>{
                if(this.date.isSame(moment(),'day')){
                    return 'Today';
                }else if((this.date.isSame(moment().add(1,'day'),'day'))){
                    return 'Tomorrow';
                }
               return  this.date.format('dddd')
            })(),
            string_nth_day:this.date.format('Do'),
            day:this.date.format('DD'),
            string_short_month:this.date.format('MMM'),
            string_long_month:this.date.format('MMMM'),
            month:this.date.format('MM'),
            year:this.date.format('YYYY'),
        }
    }
}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/VistaDate.js